/* Epic — narrow the glossary as you type.

   Matches the term and its "also called", not the definition body. Searching
   definitions sounds more useful and is not: type "fabric" and twenty of
   twenty entries match, which is the same as no filter with extra steps. */
(() => {
  const list = document.querySelector('[data-gl-list]');
  const q = document.querySelector('[data-gl-q]');
  if (!list || !q) return;

  const items = [...list.querySelectorAll('[data-gl-term]')];
  const count = document.querySelector('[data-gl-count]');
  const empty = document.querySelector('[data-gl-empty]');
  const total = items.length;

  const say = (n) => {
    if (count) count.textContent = n === total ? `${total} terms` : `${n} of ${total}`;
    if (empty) empty.hidden = n !== 0;
  };
  say(total);

  let frame = 0;
  q.addEventListener('input', () => {
    // One pass per frame: holding a key down fires input faster than layout
    // can keep up, and every toggle here invalidates the whole list.
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const needle = q.value.trim().toLowerCase();
      let shown = 0;
      items.forEach((el) => {
        const hit = !needle || el.dataset.glTerm.includes(needle);
        el.hidden = !hit;
        if (hit) shown += 1;
      });
      say(shown);
    });
  });
})();
